<topbar>
    <h1 topbar-title>Reconcile</h1>
</topbar>

<div class="container-content">
    <div class="content">
        <div class="wrapper">
           <div class="content-section">
            <div class="content-card">
                 <div
                            class="content-card__header content-card__header--blank">
                            <h3 class="content-card__heading">
                                Reconciliation Details
                            </h3>
                        </div>
                <div class="content-card__body">

                <stack pVertical pSize="small">

                    <form-field pLabel="Rentman Location" pSize="narrow">
                            
                            <div class="form-field__content">
                                <input
                                    type="text"
                                    name="location"
                                    id="location"
                                    value="{{location}}"
                                    disabled
                            />
                            </div>
                    </form-field>

                    <form-field pLabel="Latest Location" pSize="narrow" *ngIf="latestLocation !== ''">
                            
                            <div class="form-field__content">
                                <label>
                                    <input
                                        type="text"
                                        name="latestLocation"
                                        id="latestLocation"
                                        value="{{latestLocation}}"
                                        disabled
                                    />
                            </label>
                            </div>
                    </form-field>

                    <form-field pLabel="Registration" pSize="narrow">
                            
                            <div class="form-field__content">
                                <input
                                    type="text"
                                    name="reg"
                                    id="reg"
                                    value="{{reg}}"
                                    required
                                    disabled
                            />
                            </div>
                    </form-field>

                    <form-field pLabel="Check Date" pSize="narrow">
                            
                            <div class="form-field__content">
                                <input
                                    type="text"
                                    name="date"
                                    id="date"
                                    value="{{readableCheckinDate}}"
                                    required
                                    disabled
                            />
                            </div>
                    </form-field>

                    <form-field *ngIf="reconciliationType === presenceCheckType" pLabel="Where is the vehicle?" pSize="narrow">
                            
                            <div class="form-field__content">
                                <mat-select
                                class="form-field--s-narrow"
                                name="status"
                                [(ngModel)]="vehiclePresenceOutcome">
                                    <mat-option
                                        [value]="outcome.value"
                                        *ngFor="let outcome of displayableVehiclePresenceOutcomes"
                                    >
                                        {{ outcome.name }}
                                    </mat-option>
                                </mat-select>
                            </div>                     
                    </form-field>
                    <form-field *ngIf="vehiclePresenceOutcome.length > 0 && vehicleNotPresent">
                        <div *ngIf="isPresenceOutcomeOnRent || isPresenceOutcomeOnRentAtOtherBranch" class="form-field__content">
                                <label>RA Number: </label>
                                <input type="text" style="text-transform:uppercase" [(ngModel)]="nonPresentialValue">
                            </div>
                            <div *ngIf="isPresenceOutcomeWorkshop" class="form-field__content">
                                <label>Enter workshop address: </label>
                                <input type="text" style="text-transform:uppercase" [(ngModel)]="nonPresentialValue">
                            </div>
                            <div *ngIf="isPresenceOutcomeNonRevenueMovement" class="form-field__content">
                                <label>Address: </label>
                                <input type="text" style="text-transform:uppercase" [(ngModel)]="nonPresentialValue">
                            </div>
                    </form-field>
                    <form-field *ngIf="reconciliationType === vehicleKeyCheckType" pLabel="Is the vehicle key present at the branch?" pSize="narrow">
                            
                            <div class="form-field__content">
                                <mat-select
                                class="form-field--s-narrow"
                                name="status"
                                [(ngModel)]="keyOutcome">
                                    <mat-option
                                        [value]="'Vehicle key present at branch'">
                                        {{ 'Vehicle key present at branch' }}
                                    </mat-option>
                                    <mat-option
                                        [value]="'Missing'">
                                        {{ 'Missing' }}
                                    </mat-option>
                                </mat-select>
                            </div>
                    </form-field>
                    <form-field *ngIf="reconciliationType === vehicleLockedCheckType" pLabel="Is the vehicle locked?" pSize="narrow">
                            
                            <div class="form-field__content">
                                <mat-select
                                class="form-field--s-narrow"
                                name="status"
                                [(ngModel)]="lockedOutcome">
                                    <mat-option
                                        [value]="'Locked'">
                                        {{ 'Vehicle is locked' }}
                                    </mat-option>
                                </mat-select>
                            </div>
                    </form-field>
                </stack>
                <button [disabled]="!submissionIsEnabled" (click)="submitReconciliation()"  class="btn btn--primary submission-button">Submit Reconciliation</button>
                </div>
            </div>
           </div>
        </div>
    </div>
</div>